import React, {useState, useEffect} from 'react';
import {ApolloError} from '@apollo/client';
import {Preloader} from 'components/ultra';
import ClipImage from './images/clip.png';
import ErrorPoster from './images/error.jpg';

import {
  PosterWrapper,
  Clips,
  Clip,
  PosterContent,
  PosterImage,
  Shadow,
} from './styles';

interface PosterProps {
  src?: string;
  loading?: boolean;
  error?: ApolloError;
  onFinishLoading?(): void;
}

export function Poster({
  loading,
  error,
  onFinishLoading,
  ...props
}: PosterProps) {
  const [src, setSrc] = useState<string | null>(null);

  useEffect(() => {
    if (props.src) {
      setSrc(props.src);
      onFinishLoading();
    }
  }, []);

  useEffect(() => {
    if (props.src && (props.src !== src || !src)) {
      const preloader = new Image();
      preloader.onload = _evt => {
        if (preloader.currentSrc === props.src) {
          setSrc(props.src);
          onFinishLoading();
        }
      };
      preloader.onerror = () => {
        setSrc(ErrorPoster);
        onFinishLoading();
      };
      preloader.src = props.src;
      return () => {
        preloader.onload = null;
        preloader.onerror = null;
      };
    }
  }, [props, src]);

  const preloader = loading && <Preloader />;
  const errorMessage = error ? <img src={ErrorPoster} /> : null;
  const image = src ? <img src={src} /> : null;

  return (
    <PosterWrapper>
      <Clips>
        <Clip>
          <img src={ClipImage} />
        </Clip>
        <Clip>
          <img src={ClipImage} />
        </Clip>
      </Clips>
      <PosterContent>
        <PosterImage>
          {preloader}
          {errorMessage}
          {image}
          <Shadow />
        </PosterImage>
      </PosterContent>
    </PosterWrapper>
  );
}
